import { useState } from 'react'
import type { TransactionType } from '../_transaction_types/transaction.types'

function useTransactionsFilters() {
  const [transactionTypeId, setTransactionTypeId] = useState<
    TransactionType | 'all'
  >('all')
  const [startDate, setStartDate] = useState(() => {
    const date = new Date('2000-01-01')
    date.setHours(0, 0, 0, 0)
    return date
  })
  const [endDate, setEndDate] = useState<Date>(() => {
    const date = new Date()
    date.setHours(23, 59, 59, 999)
    return date
  })

  return {
    transactionTypeId,
    setTransactionTypeId,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
  }
}

export { useTransactionsFilters }
